import { Activity } from "lucide-react";
import { ActivityIcon, ActionBadge, formatTime } from "./shared";

export default function AuditFeed({ entries = [], title = "Audit Log — This Product", testId = "product-audit-log" }) {
    return (
        <div className="border border-[#2A2A2A] bg-jet-elev1" data-testid={testId}>
            <div className="flex items-center justify-between border-b border-[#2A2A2A] px-5 py-3">
                <div className="flex items-center gap-3">
                    <Activity className="w-3 h-3 text-signal" />
                    <span className="overline">{title}</span>
                </div>
                <span className="text-xs font-mono text-snow-muted">{entries.length} entries</span>
            </div>
            {entries.length === 0 ? (
                <div className="px-5 py-8 text-center text-snow-muted text-xs font-mono">
                    No audit entries yet.
                </div>
            ) : (
                <ul className="divide-y divide-[#2A2A2A]">
                    {entries.map((a) => (
                        <li
                            key={a.id}
                            data-testid={`audit-entry-${a.id}`}
                            className="px-5 py-3 flex items-start gap-4 hover:bg-white/[0.03] transition-colors"
                        >
                            <ActivityIcon type={a.action_type} />
                            <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2 flex-wrap">
                                    <ActionBadge type={a.action_type} />
                                    <span className="font-mono text-sm text-snow truncate">
                                        {a.target_label || (a.target_id || "").slice(0, 8)}
                                    </span>
                                </div>
                                {a.reason && (
                                    <div className="text-xs text-snow-dim mt-1 font-mono italic">
                                        "{a.reason}"
                                    </div>
                                )}
                                {a.metadata && a.metadata.from && a.metadata.to && (
                                    <div className="text-[11px] text-snow-muted mt-1 font-mono">
                                        {a.metadata.from} →{" "}
                                        <span className="text-signal">{a.metadata.to}</span>
                                    </div>
                                )}
                            </div>
                            <div className="text-right text-[11px] font-mono text-snow-muted whitespace-nowrap tabular-nums">
                                <div>{a.operator_email}</div>
                                <div className="mt-0.5">{formatTime(a.timestamp)}</div>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
